export default {
    name: 'TermsOfService',
    components: {
    },
    data() {
        return {

        }
    },
    created() {
    },
    methods: {
        handleAccept() {

            this.$router.replace("/home");
            window.$cookies.set('metfone-user', 'accept-page');
        },
        handleCancel() {
            window.$cookies.remove('metfone-user');
            this.$bridge.callHandler("closeApp");
        }
    }
}
